// Vendors
import { SnackbarComponent } from '@openbank/ziniaweb-ui-components';
import { ReactChildrenType } from '@gruposantander/opbpay-ui-core-models';
import React from 'react';
// Components
import { FeatureFlagComponent } from 'components/feature-flag/feature-flag.component';
// Constants
import {
  SESSION_EXPIRE_FF_PROPS,
  SESSION_EXPIRES_SNACKBAR_PROPS,
} from './constants/session-expire.constants';
// Hooks
import { useSessionExpireHook } from './hooks/session-expire.hook';
// Utilities
import { sessionExpireSnackbarShouldBeOpened } from './utils/session-expire.utils';

const SessionExpireProvider = ({ children }: ReactChildrenType): React.ReactNode => {
  const { handleCloseWarningSnackbarEvent, sessionWarningMessage } = useSessionExpireHook();

  return (
    <>
      {children}
      <FeatureFlagComponent {...SESSION_EXPIRE_FF_PROPS}>
        <SnackbarComponent
          {...{
            ...SESSION_EXPIRES_SNACKBAR_PROPS,
            onCloseButton: handleCloseWarningSnackbarEvent,
            open: sessionExpireSnackbarShouldBeOpened(sessionWarningMessage),
            title: sessionWarningMessage,
          }}
        />
      </FeatureFlagComponent>
    </>
  );
};

export { SessionExpireProvider };
